export default __webpack_public_path__ + "static/small-business-economy-accomplishment-2e-96f9677dfe21c225e0c6d3b5c120912a.webp";